import { CompaniesFormTabMentors } from "../CompaniesFormTabs/CompaniesFormTabMentors"
import { CompaniesFormTabMentorings } from "../CompaniesFormTabs/CompaniesFormTabMentorings"
import { Tabs } from "@/molecules"
import { useState } from "react"
import { MentoringDataType } from "@/types/mentoring"
import { Company } from "@/types/company"

interface CompaniesFormProps {
  companyId: string
  company?: Company | null
  companyMentorId?: number
  meta: any
  mentorings: MentoringDataType[]
  onRefresh?: () => void
  onLoadMore?: (page: number) => void // Adicionado para suportar scroll infinito
}

export const CompaniesForm = ({
  companyId,
  company,
  companyMentorId,
  mentorings,
  meta,
  onRefresh,
  onLoadMore, // Recebe do CompanyDetail
}: CompaniesFormProps) => {
  const [currentTab, setCurrentTab] = useState<string>("1")

  return (
    <div className="flex w-full flex-1 flex-col gap-8">
      <div className="grid-cols-12 gap-[20px] rounded-[8px]">
        <div className="flex flex-col">
          <div className="sticky top-[60px] z-10 items-center justify-between rounded-tl-[8px] rounded-tr-[8px] bg-dark-500 px-12 py-4">
            <Tabs
              defaultTab="1"
              onTabChange={setCurrentTab}
              tabs={[
                { id: "1", label: "Mentorias" },
                { id: "2", label: "Mentores" },
              ]}
            />
          </div>

          <div className="rounded-bl-[8px] rounded-br-[8px] bg-dark-500 px-5 py-4">
            {currentTab === "1" && (
              <CompaniesFormTabMentorings
                companyId={companyId}
                company={company}
                meta={meta}
                mentoringsData={mentorings}
                onRefresh={onRefresh}
                onLoadMore={onLoadMore} // Repassa a função de busca incremental
              />
            )}
            {currentTab === "2" && (
              <CompaniesFormTabMentors
                companyId={companyId}
                companyMentorId={companyMentorId}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
